// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading-dots_loading__6weZp","spacer":"loading-dots_spacer__O34Hd","blink":"loading-dots_blink__nuMVf"};